import imageUrlBuilder from "@sanity/image-url";
import { client } from "../client.js";

const builder = imageUrlBuilder(client);
function urlFor(source) {
  return builder.image(source);
}

const OneBlog = ({ titre, categories, lien, description, mainImage, date }) => {
  return (
    <li
      className={`flex bg-[#15202B] hover:bg-[#1b272c] transition-colors duration-500 ease-in-out rounded p-2 pb-4 border-t-[3px] ${
        categories === "HTML & CSS" ? "border-[#c3e88d]" : ""
      } 
      ${categories === "JAVASCRIPT" ? "border-[#ffcb6b]" : ""} group`}
    >
      <a
        target="_blank"
        rel="noreferrer"
        href={lien}
        className="flex flex-col w-full space-y-4 items-center"
      >
        <p className="text-[#c3e88d]">
          {categories.map((categorie) => categorie)}
        </p>
        <div className="relative h-40 w-full flex justify-center items-center overflow-hidden">
          <img
            className="h-40 w-full block object-cover  group-hover:scale-110 transition-transform duration-500 ease-in-out"
            src={urlFor(mainImage).url()}
            alt="blogImage"
          />
        </div>
        <span className="text-sm border py-1 px-3">
          {new Date(date).toLocaleDateString()}
        </span>
        <h3 className="flex-1 text-lg leading-5 text-center text-[#82aac1]">
          {titre}
        </h3>
        <p className="text-sm text-center text-gray-300">
          {truncatDesc(description)}
        </p>
      </a>
    </li>
  );
};

// const truncatTitre = (str) => {
//   // console.log(str.substring(0, 20).length);
//   return str.length > 35 ? `${str.substring(0, 35)}...` : str;
// };

const truncatDesc = (str) => {
  // console.log(str.substring(0, 20).length);
  return str.length > 100 ? `${str.substring(0, 100)}...` : str;
};

export default OneBlog;
